import { Toolbar } from "@mui/material";

import { useAppDispatch, useAppSelector } from "~/app/store";
import { NavBarButtonGroup, UnselectButton } from "~/features/navbar/Navbar";

import { mixpanelTrack, useMixpanelPageName } from "~/lib/mixpanel-tracking";

import { MovePickButton } from "./MovePickButton";
import { selectPick, setOpenToteOrLoosePickId } from "./shipOrder.slice";

export function OrderToolbar() {
  const trackedPageName = useMixpanelPageName();
  const dispatch = useAppDispatch();

  const openToteOrLoosePickId = useAppSelector(
    (state) => state.shipOrder.openToteOrLoosePickId
  );
  const selectedPick = useAppSelector((state) => state.shipOrder.selectedPick);

  const canMovePick = selectedPick && selectedPick.status === "Completed";

  return (
    <Toolbar>
      <UnselectButton
        onClick={() => {
          if (selectedPick) {
            mixpanelTrack({
              trackedPageName,
              type: "Button Click",
              label: "Unselect Pick",
              eventProperties: {
                "Pick ID": selectedPick.pickId
              }
            });
            dispatch(selectPick(null));
          }
          if (!selectedPick && openToteOrLoosePickId) {
            mixpanelTrack({
              trackedPageName,
              type: "Button Click",
              label: "Unselect Tote",
              eventProperties: {
                "Tote ID": openToteOrLoosePickId
              }
            });
            dispatch(setOpenToteOrLoosePickId(null));
          }
        }}
      />
      <NavBarButtonGroup>
        {!!canMovePick && <MovePickButton />}
      </NavBarButtonGroup>
    </Toolbar>
  );
}
